import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000,
});

// Interceptor de resposta - logout automático em 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      sessionStorage.removeItem('cf_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
